//@author: travis
import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { RateService } from "../../../services/rate.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-dropdown-rate-group")
@Component({
    selector: "s25-ng-dropdown-rate-group",
    template: `
        @if (items) {
            <s25-ng-generic-multiselect-dropdown
                [value]="value()"
                [hasFav]="false"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="false"
                [apiBean]="apiBean"
                [serverSide]="serverSide"
                [placeholder]="'Select Rate Groups'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                (valueChange)="onValueChange($event)"
                [hasDone]="hasDone"
            />
        }
    `,
    styles: `
        ::ng-deep s25-ng-dropdown-rate-group .ngDropdownPaginated a.select2-choice div:first-child {
            display: inline-block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25DropdownMultiRateGroupDropdown extends S25DropdownAbstract implements OnInit {
    @Input() hasDone: boolean;

    constructor() {
        super();
    }

    ngOnInit() {
        RateService.getRateGroupItems().then((items) => {
            this.items = items;
            this.onLoad && this.onLoad();
            this.cd.detectChanges();
        });
    }
}
